var _rect, _rect2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImagesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.949219,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.949219,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#EDEDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7.44922H6.5C6.22386 7.44922 6 7.67308 6 7.94922V16.9492C6 17.2254 6.22386 17.4492 6.5 17.4492H17.5C17.7761 17.4492 18 17.2254 18 16.9492V7.94922C18 7.67308 17.7761 7.44922 17.5 7.44922Z",
    stroke: "#767676",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14.9492L9.14375 11.8054C9.19027 11.7582 9.24573 11.7207 9.30689 11.695C9.36805 11.6694 9.43369 11.6562 9.5 11.6562C9.56631 11.6562 9.63195 11.6694 9.69311 11.695C9.75427 11.7207 9.80973 11.7582 9.85625 11.8054L12.6438 14.5929C12.6903 14.6402 12.7457 14.6777 12.8069 14.7033C12.8681 14.7289 12.9337 14.7421 13 14.7421C13.0663 14.7421 13.1319 14.7289 13.1931 14.7033C13.2543 14.6777 13.3097 14.6402 13.3562 14.5929L14.6438 13.3054C14.6903 13.2582 14.7457 13.2207 14.8069 13.195C14.8681 13.1694 14.9337 13.1562 15 13.1562C15.0663 13.1562 15.1319 13.1694 15.1931 13.195C15.2543 13.2207 15.3097 13.2582 15.3562 13.3054L18 15.9492",
    stroke: "#767676",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 11.4492C14.1642 11.4492 14.5 11.1134 14.5 10.6992C14.5 10.285 14.1642 9.94922 13.75 9.94922C13.3358 9.94922 13 10.285 13 10.6992C13 11.1134 13.3358 11.4492 13.75 11.4492Z",
    fill: "#767676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagesIcon);
export default __webpack_public_path__ + "static/media/images_icon.d95d6d78fe3b753f551f4e952e2ca37d.svg";
export { ForwardRef as ReactComponent };